<template>
  <cms-shell :data="data" title="Global Countdown" @up="$emit('up', -1, data)" @down="$emit('down', 1, data)" @remove="$emit('remove', data)">
  </cms-shell>
</template>

<script>
    import CmsShell from "./CmsShell";

    export default {
      components: {CmsShell},
      name: "cms-global-countdown",
      props:['data']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cms/CmsGlobalCountdown.vue